module.exports = new __parcel__URL__("sacredselection.6bba31b5.png").toString();